import { Context, Schema } from "effect";
class CurrentUserSchema extends Schema.Class("@superwall/api/CurrentUser")({
    userId: Schema.Number,
    roles: Schema.Array(Schema.Union(Schema.Literal("SUPERADMIN"), Schema.Literal("CUSTOMER"), Schema.Literal("OWNER"), Schema.Literal("ADMIN"))),
    permissions: Schema.Array(Schema.String)
}) {
}
class CurrentUserContext extends Context.Tag("@superwall/api/CurrentUser")() {
}
const CurrentUserOptional = CurrentUserSchema.pipe(Schema.Option);
class CurrentUserOptionalContext extends Context.Tag("@superwall/api/CurrentUserOptional")() {
}
export { CurrentUserSchema as Schema, CurrentUserOptional as OptionalSchema, CurrentUserContext as Context, CurrentUserOptionalContext as OptionalContext,  };
